import React, { useRef } from 'react'
import { Bar } from 'react-chartjs-2'
import { Divider, Grid, Paper, Typography } from '@mui/material'
import '../../../styles/report.css'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import RYGGLegend from '../adminreport/RYGGLegend'
import RYGGHorizontalBar from '../adminreport/RYGGHorizontalBar'
/** 
 * 
 * This component is expecting the following input. it will iterate through the BarChart section
{
    "Order": "50",
    "Visible": "1",
    "Label": "",
    "ComponentType": "KEY AREA CHART",
    "BarChart": [
        {
            "Order": "10",
            "Visible": "1",
            "Label": "HEART",
            "Score": "58",
            "ValueGrade": "2"
        }
    ]
}
*/

const AdminBiometricSection = (props) => {
    const FilteredSections = [...props.component.Sections].filter((a) => { return a.Visible === '1' })
    const OrderedSections = FilteredSections.sort((a, b) => { return parseInt(a.Order) - parseInt(b.Order) })

    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }
    

    return (
        <Grid item lg={12} md={12} sm={12} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>
            <motion.div variants={motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>

                    <Grid item xs={12}>
                        <Typography variant='h4' align="center">
                            {props.component && props.component.Label}
                        </Typography>
                    </Grid>


                    <Grid item xs={12} m={1}>
                        <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
                    </Grid>

                    <Grid item xs={12}>
                        <Paper elevation={props.elevationdisabled === true ? 0 : 1} sx={{ padding: '40px' }}>
                           {
                            OrderedSections.map((x,i) => {
                                return (
                                    <RYGGHorizontalBar displayValues={x} />
                                )
                                })
                           }

                        </Paper>
                    </Grid>
                    <Grid item xs={12}>
                        <RYGGLegend />
                    </Grid>
                </Grid>
            </motion.div>
        </Grid>
    )
}

export default AdminBiometricSection